// import { Tabs } from 'antd';
// import { RadarChartOutlined, DollarOutlined, SettingOutlined, SafetyCertificateOutlined } from '@ant-design/icons';
// import CommandSystemCmp from "./CommandSystem";
// import Financial from '../Financial';
// import Operational from '../Operational';
// import Compliance from '../Compliance';

// const CommandSystem = () => {
//   const items = [
//     {
//       key: 'radar',
//       label: (
//         <span>
//           <RadarChartOutlined style={{ marginRight: '8px' }} />
//           Radar+
//         </span>
//       ),
//       children: <CommandSystemCmp />,
//     },
//     {
//       key: 'financial',
//       label: (
//         <span>
//           <DollarOutlined style={{ marginRight: '8px' }} />
//           Financial
//         </span>
//       ),
//       children: <Financial />,
//     },
//     {
//       key: 'operations',
//       label: (
//         <span>
//           <SettingOutlined style={{ marginRight: '8px' }} />
//           Operations
//         </span>
//       ),
//       children: <Operational />,
//     },
//     {
//       key: 'compliance',
//       label: (
//         <span>
//           <SafetyCertificateOutlined style={{ marginRight: '8px' }} />
//           Compliance
//         </span>
//       ),
//       children: <Compliance />,
//     },
//   ];

//   return (
//     <>
//       <Tabs
//         type="card"
//         items={items}
//         defaultActiveKey="radar"
//         style={{ marginTop: '10px' }}
//       />
//     </>
//   );
// };

// export default CommandSystem;

import { useState } from 'react';
import { Select } from 'antd';
import {
  RadarChartOutlined,
  DollarOutlined,
  SettingOutlined,
  SafetyCertificateOutlined,
} from '@ant-design/icons';

import CommandSystemCmp from './CommandSystem';
import Financial from '../Financial';
import Operational from '../Operational';
import Compliance from '../Compliance';

const { Option } = Select;

const CommandSystem = () => {
  const [selectedKey, setSelectedKey] = useState('radar');

  const handleChange = (value) => {
    setSelectedKey(value);
  };

  const options = [
    {
      key: 'radar',
      label: 'Radar+',
      icon: <RadarChartOutlined />,
      content: <CommandSystemCmp />,
    },
    {
      key: 'financial',
      label: 'Financial',
      icon: <DollarOutlined />,
      content: <Financial />,
    },
    {
      key: 'operations',
      label: 'Operations',
      icon: <SettingOutlined />,
      content: <Operational />,
    },
    {
      key: 'compliance',
      label: 'Compliance',
      icon: <SafetyCertificateOutlined />,
      content: <Compliance />,
    },
  ];

  const selectedItem = options.find((item) => item.key === selectedKey);

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '16px' }}>
        <Select
          defaultValue="radar"
          onChange={handleChange}
          style={{ width: 200 }}
        >
          {options.map((item) => (
            <Option key={item.key} value={item.key}>
              <span style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                {item.icon}
                {item.label}
              </span>
            </Option>
          ))}
        </Select>
      </div>

      <div>{selectedItem?.content}</div>
    </div>
  );
};

export default CommandSystem;
